const resolveApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL || ''
  try {
    const url = new URL(envUrl)
    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      url.hostname = window.location.hostname
    }
    return url.toString().replace(/\/$/, '')
  } catch {
    return envUrl
  }
}

export const apiUrl = resolveApiUrl()

export const apiBareUrl = apiUrl.replace(/(\/api)$/, '')
